<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import { merge } from "lodash";
import { BaseAtom } from "components/cards/atoms";
import { TextParticle, ButtonParticle, } from "components/cards/particles/YinzCam";
import ImageParticle from "components/cards/particles/YinzCam/Core/Image/ImageParticle.svelte";
export let container;
export let playerStats = undefined;
export let personalStats = undefined;
export let statsList;
export let personalStatsList;
export let borderRadius;
export let colorContainerBG;
export let colorStatBackground;
export let colorTabBorder;
let atomWidthRem;
let statsDataSource = [];
// $: statsDataSource = playerStats?.filter((playerStat) =>
//     statsList?.includes(playerStat?.name?.text),
// );
$: if ((personalStatsList === null || personalStatsList === void 0 ? void 0 : personalStatsList.length) > 0) {
    statsDataSource = personalStats === null || personalStats === void 0 ? void 0 : personalStats.filter((stat) => { var _a; return personalStatsList === ((_a = stat === null || stat === void 0 ? void 0 : stat.name) === null || _a === void 0 ? void 0 : _a.text); });
}
else if ((statsList === null || statsList === void 0 ? void 0 : statsList.length) > 0) {
    statsDataSource = playerStats === null || playerStats === void 0 ? void 0 : playerStats.filter((playerStat) => { var _a; return statsList === ((_a = playerStat === null || playerStat === void 0 ? void 0 : playerStat.name) === null || _a === void 0 ? void 0 : _a.text); });
}
$: statsDisplay =
    (statsDataSource === null || statsDataSource === void 0 ? void 0 : statsDataSource.length) > 0
        ? statsDataSource
        : [
            {
                [`${(personalStatsList === null || personalStatsList === void 0 ? void 0 : personalStatsList.length) > 0 ? personalStatsList : statsList}`]: "0",
            },
        ];
</script>

<BaseAtom
    bind:_clientWidthRem={atomWidthRem}
    _isotope="StatsNumber"
    _cssVariablePrefix="stat-number"
    {...container}
    {borderRadius}
    {colorContainerBG}
    {colorStatBackground}
    {colorTabBorder}
>
    <div class="cards-container">
        {#each statsDisplay || [] as stat, id}
            {#if stat.name !== undefined}
                <div class="stat-card">
                    <div class="highlight-shape">
                        <ButtonParticle
                            {...merge({}, stat.highlightBox, {
                                container: {
                                    background: {
                                        color: `${stat.highlightColor}`,
                                    },
                                },
                            })}
                        />
                    </div>
                    <div class="image-text-value">
                        {#if stat?.imageSource?.source}
                            <div class="flag-image">
                                <ImageParticle
                                    _block={true}
                                    {...stat.imageSource}
                                />
                            </div>
                        {/if}
                        <TextParticle _block={true} {...stat.homeValue} />
                    </div>
                    <TextParticle _block={true} {...merge({}, stat.name, {})} />
                </div>
            {/if}
        {/each}
    </div>
</BaseAtom>

<style>
    .cards-container {
        width: 100%;
        height: 100%;
        display: flex;
        gap: 0.125rem;
        flex-wrap: wrap;
        background-color: var(--stat-number-color-container-bg, #fff);
    }
    .stat-card {
        display: flex;
        flex-direction: column;
        flex: 1 1;
        justify-content: space-evenly;
        padding: 0.75rem 0.8125rem;
        border: 1px solid var(--stat-number-color-tab-border, unset);
        border-radius: var(--stat-number-border-radius, 0.75rem);
        align-items: center;
        position: relative;
        background-color: var(
            --stat-number-color-stat-background,
            var(--theme-mode-background-color, unset)
        );
    }
    .highlight-shape {
        width: 1.625rem;
        height: 2.25rem;
        position: absolute;
        top: 0.75rem;
        left: 1.06rem;
        border-radius: var(--stat-number-border-radius, 0.75rem);
    }
    .image-text-value {
        display: flex;
        align-items: center;
        justify-content: center;
        /* gap: 0.5rem; */
    }
    .flag-image{
        max-width: 6rem;
    }</style>
